"use client"

import Icon from "@ant-design/icons"
import type { GetProps } from "antd"
import type { SVGProps } from "react"

const ESIM_PATHS = [
  "m21.148 91.875v-83.75c0-1.4883 1.2031-2.6953 2.6953-2.6953h34.922c0.83984 0 1.6289 0.39062 2.1406 1.0547l17.391 22.684c0.36328 0.47266 0.55469 1.0508 0.55469 1.6406v61.066c0 1.4883-1.2031 2.6953-2.6953 2.6953h-52.312c-1.4922 0-2.6953-1.207-2.6953-2.6953zm2.6953 0h52.312v-61.066l-17.391-22.684h-34.922z",
  "m35.34 80.887h29.32v-36.691h-29.32zm32.016 1.3477-0.007813 0.14062c-0.0625 0.63281-0.56641 1.1367-1.2031 1.2031l-0.13672 0.003906h-32.016l-0.13672-0.003906c-0.63672-0.066406-1.1406-0.57031-1.2031-1.2031l-0.007813-0.14062v-39.387c0-0.74219 0.60156-1.3477 1.3477-1.3477h32.016l0.13672 0.007812c0.67969 0.066407 1.2109 0.64063 1.2109 1.3398z",
  "m65.875 53.945v2.6953h-31.469v-2.6953z",
  "m65.875 68.977v2.6953h-31.469v-2.6953z",
  "m46.348 70.453v11.211h-2.6953v-11.211zm10.449 0v11.211h-2.6953v-11.211zm-10.449-26.758v11.215h-2.6953v-11.215zm10.449 0v11.215h-2.6953v-11.215z",
] as const

type CustomIconComponentProps = GetProps<typeof Icon>

export type EsimIconProps = Partial<CustomIconComponentProps> & {
  color?: string
}

type EsimSvgProps = SVGProps<SVGSVGElement> & {
  color?: string
}

const EsimSvg = ({ color = "currentColor", ...props }: EsimSvgProps) => (
  <svg
    viewBox="16 0 58 94"
    width="1em"
    height="1em"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
    {...props}
  >
    {ESIM_PATHS.map((d) => (
      <path key={d} d={d} fill={color} />
    ))}
  </svg>
)

const EsimIcon = ({ color, ...props }: EsimIconProps) => (
  <Icon
    component={(svgProps: SVGProps<SVGSVGElement>) => (
      <EsimSvg {...svgProps} color={color} />
    )}
    {...props}
  />
)

export default EsimIcon
